import React, { useState, useEffect } from "react";
import moment from "moment";
import { DatePicker, Table, Tag } from "antd";
import { CalendarOutlined, DownloadOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import complaintActions from "../../redux/complaints/actions";
import { CSVLink } from "react-csv";
import SearchBar from "../../utils/Searchbar";
import ComplaintExport from "./ComplaintExport";
import "./complaints.scss";


const { getComplaintsData } = complaintActions;


const columns = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
    sorter: (a, b) => a?.key - b?.key,
    width: 100, // Fixed width
  },
  {
    title: "DATE-TIME",
    dataIndex: "date",
    sorter: (a, b) => Date?.parse(a?.createdAt) - Date?.parse(b?.createdAt), // Compare raw date-time
    width: 100, // Fixed width
    render: (text, record) => (
      <>
        <p className="m-0 p-0">
          {moment.utc(record?.createdAt)?.format("DD MMMM YYYY")}
        </p>
        <p className="m-0 p-0">
          {moment.utc(record?.createdAt)?.format("hh:mm:ss A")}
        </p>
      </>
    ),
  },
  {
    title: "COMPLAINT ID",
    dataIndex: "complaint_id",
    sorter: (a, b) => a.complainId?.localeCompare(b.complainId),
    width: 100, // Fixed width
  },
  {
    title: "COMPLAINT TYPE",
    dataIndex: "complaint_type",
    sorter: (a, b) => a.complaint_type?.localeCompare(b?.complaint_id),
    width: 100, // Fixed width
  },
  {
    title: "OPEN COMPLAINT",
    dataIndex: "open_complaint",
    width: 100, // Fixed width
  },
  {
    title: "ASSIGNED",
    dataIndex: "assigned",
    width: 100, // Fixed width
  },

  {
    title: "STATUS",
    dataIndex: "status",
    width: 100, // Fixed width
  },

  {
    title: "DISPOSITION",
    dataIndex: "disposition",
    width: 100, // Fixed width
  },
  {
    title: "DESCRIPTION",
    dataIndex: "description",
    width: 100, // Fixed width
  },
];
function Complaints() {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const { complaintsData, totalData, loading } = useSelector(
    (state) => state.complaintReducer
  );
  const { agentId } = useSelector((state) => ({
    agentId: state.authReducer.agentId,
  }));

 

  var data =
    complaintsData.complaints &&
    complaintsData.complaints.length > 0 &&
    complaintsData.complaints.map((items, index) => {
      return {
        key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
        complaint_id:
          items?.response?.txnStatusComplainResp[0]?.complaintId ||  <Tag>{""}</Tag>,
        complaint_type: items?.request?.complaintType,
        open_complaint: (
          <Tag
            color={
              items?.response?.txnStatusComplainResp[0]?.openComplaint === "N"
                ? "red"
                : "green"
            }
          >
            {items?.response?.txnStatusComplainResp[0]?.openComplaint || ""}
          </Tag>
        ),
        assigned: 
          items?.response?.txnStatusComplainResp[0]?.assigned ||  <Tag>{""}</Tag>
      ,
       
         description: (
          <Tag
            style={{
              border: "none",
              backgroundColor: "transparent",
            }}
            className="draft"
          >
            {" "}
            {items?.request.description ? (
              <textarea
                rows={2}
                readOnly
                style={{
                  outline: "none",
                  border: "none",

                  resize: "verticle",
                  overflow: "hidden", // Hide scrollbars
                  whiteSpace: "pre-wrap",

                  fontSize: "14px",
                  color: "#333",
                }}
                value={items?.request.description || ""} // Fallback for undefined values
              />
            ) : (
              <Tag>{""}</Tag>
            )}
          </Tag>
        ),

        disposition: (
          <Tag
            style={{
              border: "none",
              backgroundColor: "transparent",
            }}
            className="draft"
          >
            {" "}
            {items?.request.disposition ? (
              <textarea
                rows={2}
                readOnly
                style={{
                  outline: "none",
                  border: "none",

                  resize: "verticle",
                  overflow: "hidden", // Hide scrollbars
                  whiteSpace: "pre-wrap",

                  fontSize: "14px",
                  color: "#333",
                }}
                value={items?.request.disposition || ""} // Fallback for undefined values
              />
            ) : (
              <Tag>{""}</Tag>
            )}
          </Tag>
        ),
        date: (
          <>
            <p className="m-0 p-0">
              {moment(items.createTime).format("DD MMMM YYYY")}
            </p>
          </>
        ),
        createdAt: items.createdAt,
        status: (
          <Tag
            style={{
              border: "none",
              backgroundColor: "transparent",
            }}
            className="draft"
          >
            {items?.response?.txnStatusComplainResp[0]?.responseReason !==
            "SUCCESS" ? (
              <textarea
                rows={2}
                readOnly
                style={{
                  outline: "none",
                  border: "none",
                  resize: "verticle",
                  overflow: "hidden", // Hide scrollbars
                  whiteSpace: "pre-wrap",

                  fontSize: "14px",
                  color: "#333",
                }}
                value={
                  items?.response?.txnStatusComplainResp[0]?.responseReason ||
                  "No Reason Provided"
                } // Fallback for undefined values
              />
            ) : (
              items?.response?.txnStatusComplainResp[0]?.responseReason
            )}
          </Tag>
        ),
      };
    });

  // const handleFilterChange = (e) => {
  //     e.preventDefault()
  //     const value = e.target.value;
  //     setSearch(value);

  //     if (value.length > 1) {
  //         dispatch(getComplaintsData(0, 10, value));
  //     }
  //     if (value.length < 1) {
  //         dispatch(getComplaintsData(0, 10));
  //     }
  // };

  let timeoutId;
  const handleFilterChange = (e) => {
    // console.log(e.target.value,complaintsData?.legth);
    e.preventDefault();
    const value = e.target.value;
    if (timeoutId) {
      clearTimeout(timeoutId); // Clear the previous timeout if it exists
    }

    timeoutId = setTimeout(() => {
      if(complaintsData?.complaints?.length >= 0){
      dispatch(getComplaintsData(0, 10, value));
      }
    }, 1000);
  };

  const disabledTime = (currentDate) => {
          const now = moment();
          if (currentDate.isSame(now, 'day')) {
            return {
              disabledHours: () =>
                Array.from({ length: 24 }, (_, i) => i).filter(
                  (hour) => hour > now.hour()
                ),
              disabledMinutes: (selectedHour) => {
                if (selectedHour === now.hour()) {
                  return Array.from({ length: 60 }, (_, i) => i).filter(
                    (minute) => minute > now.minute()
                  );
                }
                return [];
              },
              disabledSeconds: () => [],
            };
          }
          return {
            disabledHours: () => [],
            disabledMinutes: () => [],
            disabledSeconds: () => [],
          };
        };

  const handlePageChange = async ( pagination, sofilters, rter ) =>
  {

    const { current, pageSize } = pagination;
    setTableParams({ current, pageSize });

    if (fromDate && toDate) {
      dispatch(
        getComplaintsData(
          current,
          pageSize,
          "",
          fromDate?.format("YYYY-MM-DD"),
          toDate?.format("YYYY-MM-DD")
        )
      );
    } else {
      dispatch(getComplaintsData(current, pageSize, "", "", "", agentId));
    }
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  // const handleToDateChange = (date) => {
  //   setToDate(date);
  //   const fromSendDate = fromDate?.format("YYYY-MM-DD");
  //   const toDate = date?.format("YYYY-MM-DD");
  //   if (fromSendDate && toDate) {
  //     dispatch(getComplaintsData(1, 10, "", fromSendDate, toDate));
  //   } else
  //   {
     
  //     dispatch(getComplaintsData(1, 10));
  //   }
  // };

  const handleToDateChange = (date) => {
    const now = moment();
    let adjustedDate = date?.clone();
  
    // Prevent future dates
    if (adjustedDate?.isAfter(now, "day")) {
      adjustedDate = now.clone();
    }
  
    // If selected date is today
    if (adjustedDate?.isSame(now, "day")) {
      if (adjustedDate.isAfter(now)) {
        adjustedDate = adjustedDate.set({
          hour: now.hour(),
          minute: now.minute(),
          second: now.second(),
        });
      }
    }
  
    // If it's same as fromDate and time is 00:00:00, set to end of day
    if (
      adjustedDate?.isSame(fromDate, "day") &&
      adjustedDate.hour() === 0 &&
      adjustedDate.minute() === 0 &&
      adjustedDate.second() === 0
    ) {
      adjustedDate = adjustedDate.set({ hour: 23, minute: 59, second: 59 });
    }
  
    setToDate(adjustedDate);
  
    // If fromDate is after new toDate, clear it
    if (adjustedDate && fromDate && adjustedDate.isBefore(fromDate)) {
      setFromDate(null);
    }
  
    // Format and dispatch
    const fromSendDate = fromDate?.format("YYYY-MM-DDTHH:mm:ss.000+05:30");
    const toSendDate = adjustedDate?.format("YYYY-MM-DDTHH:mm:ss.000+05:30");
  
    if (fromSendDate && toSendDate) {
      dispatch(getComplaintsData(1, 10, "", fromSendDate, toSendDate));
    } else {
      dispatch(getComplaintsData(1, 10));
    }
  };
  
  const disabledToDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const exportData =
    complaintsData.complaints &&
    complaintsData.complaints.length > 0 &&
    complaintsData.complaints.map((items, index) => {
    
      return {
       key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
        complaint_id:
          items?.response?.txnStatusComplainResp[0]?.complaintId || "",
        complaint_type: items?.request?.complaintType,
        assigned:items?.response?.txnStatusComplainResp[0]?.assigned || "",
        remarks: items?.response?.txnStatusComplainResp[0]?.remarks || "",
        date: moment(items.createdAt).format("DD MM YYYY"),
        status: items?.response?.txnStatusComplainResp[0]?.responseReason,
      }
    });
    useEffect(() => {
      if ( !agentId || agentId == "" )
      {
      
        dispatch(getComplaintsData());
      } else
      {
     
        dispatch(getComplaintsData(0, 10,"","","",agentId));
      }
    }, [agentId, dispatch]);

  return (
    <div className="mainContain">
      <h1 className="transaction">Complaints</h1>

      <div className="datesearchFi">
        <div className="">
          <SearchBar onChange={handleFilterChange} />
        </div>
        <div className="inputfatef">
          <div>
            {/* <span>From (DD-MM-YYYY)</span> */}
            <DatePicker
              value={fromDate}
              style={{ width: "100%", border: "none" }}
              onChange={handleFromDateChange}
              disabledDate={disabledDate}
              format="DD-MM-YYYY HH:mm:ss"
              showTime
              placeholder="From (DD-MM-YYYY HH:mm:ss)" // Placeholder added here
              suffixIcon={
                <CalendarOutlined style={{ color: "rgba(22, 22, 22, 0.25)" }} />
              }
            />
          </div>
          <div>
            {/* <span>To (DD-MM-YYYY)</span> */}
            <DatePicker
              value={toDate}
              style={{ width: "100%", border: "none" }}
              onChange={handleToDateChange}
              disabledDate={disabledToDate}
              format="DD-MM-YYYY HH:mm:ss"
              showTime={{
                format: "HH:mm:ss",
                disabledTime: disabledTime
              }}
              placeholder="To (DD-MM-YYYY HH:mm:ss)" // Placeholder added here
              suffixIcon={
                <CalendarOutlined style={{ color: "rgba(22, 22, 22, 0.25)" }} />
              }
            />
          </div>
        </div>
      </div>
      {data?.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px",
          }}
        >
          <ComplaintExport />
        </div>
      )}

      <div className="mt-3">
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          scroll={{ x: 600 }}
          pagination={{
            total: totalData,
            current: tableParams.current,
            pageSize: tableParams.pageSize,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "20", "50"],
          }}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
}

export default Complaints;